import React, { useState } from 'react';
import '../css/Header.css';
import { FaShoppingCart, FaBars, FaTimes } from 'react-icons/fa';
import logo from '../assets/images/logo.jpg';
import Cart from './Cart';
import { useCart } from '../context/CartContext';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { 
        cartItems = [], // Встановлюємо значення за замовчуванням
        isCartOpen, 
        setIsCartOpen, 
        removeFromCart, 
        updateQuantity 
    } = useCart();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const toggleCart = (e) => {
        e.preventDefault();
        setIsCartOpen(!isCartOpen);
    };

    return (
        <>
            <header className="main-header">
                <div className="logo">
                    <a href="/">
                        <img src={logo} alt="Logo" className="header-logo"/>
                    </a>
                </div>

                {/* Посилання в навігації (видно на мобільних при відкритому меню) */}
                <nav className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
                    <a href="/">Товари та послуги</a>
                    <a href="/contacts">Контакти</a>
                    <a href="/about">Про нас</a>
                    {/* Посилання на "Корзину" – лише для мобільного меню */}
                    <a href="/cart" className="cart-mobile-link" onClick={toggleCart}>
                        <FaShoppingCart />
                        <span>Корзина</span>
                        {cartItems?.length > 0 && (
                            <span className="cart-count">{cartItems.length}</span>
                        )}
                    </a>
                </nav>

                <div className="menu-icon" onClick={toggleMenu}>
                    {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
                </div>

                {/* Іконка "Корзини" – лише для десктопу */}
                <div className="cart-icon">
                    <a href="/cart" onClick={toggleCart}>
                        <FaShoppingCart size={24} />
                        {cartItems?.length > 0 && (
                            <span className="cart-count">{cartItems.length}</span>
                        )}
                    </a>
                </div>
            </header>

            <Cart 
                isOpen={isCartOpen}
                onClose={() => setIsCartOpen(false)}
                items={cartItems}
                onRemoveItem={removeFromCart}
                onUpdateQuantity={updateQuantity}
            />
        </>
    );
};

export default Header;
